import React from 'react';
import { Card } from './ui/card';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { CheckCircle2 } from 'lucide-react';

const ConditionsTreated = ({ conditions }) => {
  return (
    <section id="conditions" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
              Conditions Treated
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              Comprehensive care for a wide range of pediatric blood disorders and cancers
            </p>
            <div className="w-24 h-1 bg-teal-600 mx-auto rounded-full mt-6"></div>
          </div>
          
          <Accordion type="single" collapsible className="space-y-4">
            {conditions?.map((category, idx) => (
              <AccordionItem
                key={idx}
                value={`item-${idx}`}
                className="border border-slate-200 rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow"
              >
                <AccordionTrigger className="px-6 py-5 hover:bg-teal-50 transition-colors text-left">
                  <span className="text-xl font-bold text-slate-900">{category.category}</span>
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-6 pt-2 bg-white">
                  <div className="grid sm:grid-cols-2 gap-3">
                    {category.conditions?.map((condition, condIdx) => (
                      <div
                        key={condIdx}
                        className="flex items-start space-x-3 p-3 rounded-lg hover:bg-slate-50 transition-colors"
                      >
                        <CheckCircle2 className="w-5 h-5 text-teal-600 mt-0.5 flex-shrink-0" />
                        <span className="text-slate-700">{condition}</span>
                      </div>
                    ))}
                  </div>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default ConditionsTreated;